<script>
    import {APP_PATH, APP_VERSION} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import passportsStore from "./stores/passportsStore";
    import AppAlert from "./stores/alerts";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Users from "./users/Users.svelte";
    import Members from "./members/Members.svelte";
    import Elections from "./members/Elections.svelte";
    import MemberEdit from "./members/MemberEdit.svelte";
    import Products from "./products/Products.svelte";
    import Orders from "./orders/Orders.svelte";
    import Passports from "./passports/Passports.svelte";
    import Pages from "./settings/pages/Pages.svelte";
    import Shipping from "./settings/shipping/Shipping.svelte";
    import Reports from "./reports/Reports.svelte";
    import Documents from "./documents/Documents.svelte";
    import Import from "./import/Import.svelte";
    import PassportsClient from "./passports/PassportsClient.svelte";
    import PassportsReport from "./passports/PassportsReport.svelte";

    let appInitialized = false;

    const initUser = async () => {
        let coo = cookie.get('hva-app') || null;
        if (coo) {
            $user.token = coo;
        }
    }

    const appInitialize = () => {
        const onSuccess = result => {
            $user.id = result.user.id;
            $user.name = result.user.name;
            $user.username = result.user.username;
            $user.is_admin = ~~result.user.is_admin;
            $user.role_id = ~~result.user.role_id;

            $app.regions = result.regions;
            $app.vat_regimes = result.vat_regimes;
            $app.shop_url = result.shop_url;
            $passportsStore.prefix = result.passport_prefix;
            $app.passports_for_sync = result.passports_for_sync;

            if (APP_VERSION !== result.app_version) {
                alert("Η έκδοση της εφαρμογής που χρησιμοποιείται είναι πεπερασμένη!\nΚαθαρίστε την προσωρινή μνήμη (cache) του browser σας και ανανεώστε αυτή την σελίδα για να χρησιμοποιήσετε την πιο πρόσφατη έκδοση της εφαρμογής.");
            }

            appInitialized = true;

            // Check for passports alert
            if ($app.passports_for_sync > 0) {
                let last_date = cookie.get('hva-passports');
                if (result.passports_last_date && result.passports_last_date != last_date) {
                    cookie.create('hva-passports', result.passports_last_date);
                    AppAlert.confirm("Διαβατήρια", "Υπάρχουν διαβατήρια προς αποστολή στο Ε.Μ.Ζ.Σ.\nΘέλετε να μεταβείτε στην ενότητα των διαβατηρίων;", () => {
                        router.go('/app/passports')();
                    });
                }
            }
        }

        const onFailure = err => {
        };

        if ($user.token != null && $user.token !== '') {
            R.handle(R.app.initialize, [], onSuccess, onFailure);
        }

    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    initUser();

    $: {
        if ($user.token != null && !appInitialized) {
            appInitialize();
        }

        if (appInitialized) {
            if (router.url === "/") {
                router.go(`/${APP_PATH}`)();
            }
        }
    }
</script>


{#if !$user.token}
    <Login/>
{:else if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader/>
    <AppMenu/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <Route match="/">
                    <Route match="{APP_PATH}">
                        <Route match="members">
                            <Members/>
                        </Route>
                        <Route match="elections">
                            <Elections/>
                        </Route>
                        <Route match="new-member" let:router>
                            <MemberEdit memberId="0"/>
                        </Route>
                        <Route match="member" let:router>
                            <MemberEdit memberId="{ router.id }"/>
                        </Route>
                        <Route match="reports">
                            <Reports/>
                        </Route>
                        <Route match="products">
                            <Products/>
                        </Route>
                        <Route match="orders">
                            <Orders/>
                        </Route>
                        <Route match="passports">
                            <Passports/>
                        </Route>
                        <Route match="passports-report">
                            <PassportsReport/>
                        </Route>
                        <Route match="documents">
                            <Documents/>
                        </Route>
                        <Route match="pages">
                            <Pages/>
                        </Route>
                        <Route match="users" guard="{ user.isAdmin }">
                            <Users/>
                        </Route>
                        <Route match="shipping">
                            <Shipping/>
                        </Route>
                        <Route match="import">
                            <Import/>
                        </Route>
                    </Route>
                </Route>
            </div>
        </div>
    </main>
{/if}

{#if $passportsStore.sync_data != null}
    <PassportsClient/>
{/if}

<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>